module.exports = __webpack_public_path__ + "assets/img/swiper-img5-a9eb3047.png";